
export default function parseLink(url) {
  try {
    const decoded = decodeURIComponent(url);
    // eventuali modifiche al link, es: aggiunta di parametri, tracciamento, ecc.
    return decoded;
  } catch (e) {
    return url; // fallback
  }
}
